import { FormattedMessage } from 'react-intl';

import { OrderTriggerName } from './order-workflow';

export { OrderTriggerName } from './order-workflow';

export class OrderTrigger {
    static readonly ORDER_STATE_CHANGED = new OrderTrigger(
        OrderTriggerName.ORDER_STATE_CHANGED,
        (
            <FormattedMessage
                id='OrderTrigger.order_state_changed'
                description='The displayed value for the OrderTrigger order_state_changed'
                defaultMessage='Order state changed'
            />
        )
    );
    static readonly ORDER_CANCEL = new OrderTrigger(
        OrderTriggerName.ORDER_CANCEL,
        (
            <FormattedMessage
                id='OrderTrigger.order_cancel'
                description='The displayed value for the OrderTrigger order_cancel'
                defaultMessage='Cancel order'
            />
        )
    );
    static readonly ORDER_CANCELLED = new OrderTrigger(
        OrderTriggerName.ORDER_CANCELLED,
        (
            <FormattedMessage
                id='OrderTrigger.order_cancelled'
                description='The displayed value for the OrderTrigger order_cancelled'
                defaultMessage='Order cancelled'
            />
        )
    );
    static readonly ORDER_PLACED = new OrderTrigger(
        OrderTriggerName.ORDER_PLACED,
        (
            <FormattedMessage
                id='OrderTrigger.order_placed'
                description='The displayed value for the OrderTrigger order_placed'
                defaultMessage='Order placed'
            />
        )
    );

    static readonly ALL = [OrderTrigger.ORDER_STATE_CHANGED, OrderTrigger.ORDER_CANCEL, OrderTrigger.ORDER_CANCELLED, OrderTrigger.ORDER_PLACED];

    constructor(
        public readonly value: OrderTriggerName,
        public readonly displayName: React.ReactNode
    ) {}

    static getByValue(trigger: string): OrderTrigger | undefined {
        return this.ALL.find((item) => item.value === trigger);
    }
}
